// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import RemoteControl from './plugin/RemoteControl';
import VueNativeSock from 'vue-native-websocket';
//import SocketPlugin from './plugin/socket'
import "core-js/stable";

//import RPIController from './helpers/RPIController';

//import i18n from './i18n';

import './assets/css/main.css';
import LangControl from './plugin/LangControl';
import DeviceType from './helpers/DeviceType';
//import socket from './store/modules/socket';
//import socketLogger from './store/modules/socket-logger';

// RPIController.init();

Vue.config.productionTip = false;
Vue.use(RemoteControl);
Vue.prototype.$eventBus = new Vue();
//Vue.loadScript("http://192.168.50.200:8080/static/hcap.js");

Vue.config.errorHandler = function(err, vm, info) {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.log(err, vm, info);
  //this.$socket.sendObj({"err": err, "vm": vm, "info": info});
  //this.$logger.sendObj({"err": err, "vm": vm, "info": info});
  //socketLogger.sendObj({"err": err, "vm": vm, "info": info});
};

/*
Vue.config.warnHandler = function(msg, vm, trace) {
  // handle warn
  // `trace` is the component hierarchy trace
  console.log(err, vm, info);
  this.$socket.sendObj({"msg": msg, "vm": vm, "info": trace});
  //this.$logger.sendObj({"msg": msg, "vm": vm, "info": trace});
  socketLogger.sendObj({"msg": msg, "vm": vm, "info": trace});
};
*/

// Vue.prototype.$lang = (path) => {
//   const lang = store.getters['lang/getLang'];
//   path.split('.');
//   if (path[0] === undefined) return '';
//   let found = i18n[lang];
//   console.log(lang, found, i18n);
//   for (const step of path) {
//     if (!found) return '';
//     found = found[step];
//   }
//   return found;
// };

/*
Vue.use(VueNativeSock, 'ws://localhost:3333', {
  store: store,
  format: 'json',
  protocol: 'tv-app',
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
});
*/
//${process.env.SOCKET_BASE}
/*Vue.use(SocketPlugin, {
  //url: '${process.env.SOCKET_SERVER}', // hier deine Server-URL
  url: 'ws://localhost:3003', // hier deine Server-URL
  reconnectionAttempts: 10,
  reconnectionDelay: 3000,
});*/

Vue.use(LangControl);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  methods: {
    _initHcap() {
      try {
        hcap.property.setProperty({
          "key" : "display_resolution",
          "value" : "1920x1080",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-Resolution :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-Resolution : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setProperty({
          "key" : "boot_sequence_option",
          "value" : "1",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-BootSequence :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-BootSequence : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setProperty({
          "key" : "tv_channel_attribute_floating_ui",
          "value" : "0",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-FloatingAttribute :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-FloatingAttribute : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setProperty({
          "key" : "application_channel_control",
          "value" : "1",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-application_channel_control :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-application_channel_control : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setProperty({
          "key" : "clock_display",
          "value" : "0",
          "onSuccess" : function(s) {
              console.log("========================onSuccess-clock_display :", s);
          },
          "onFailure" : function(f) {
              console.log("========================onFailure-clock_display : errorMessage = " + f.errorMessage);
          }
        });
        hcap.property.setHotelMode({
          "hotelMode" : {
               'enable': 'on',
               'settings': {
                  'powerOnStatus': 'stand_by',
                  'volume': {
                    'enable': 'on',
                    'settings': { 'startVolume': { 'enable': 'on', 'level': 10 },
                    'minimumVolume': 0, 'maximumVolume': 100 }
                  },
                  'keyManagement': {
                    'enable': 'on',
                    'settings': { 'irOperation': 'normal', 'localKeyOperation': 'normal' }
                  },
              'limitedMode': {
                'enable': 'on',
                'settings': {
                  'setupMenu': 'off',
                  'programmeChange': 'off',
                  'menuDisplay': 'off',
                  'osdDisplay': 'on',
                  'systemProviderMode': 'on'
                }
              },
              'dtvProgrammeUpdate': 'Manual',
              'powerOnDefault': {
                'enable': 'off',
                'settings': {
                  'input': 'off',
                  'programme': '2',
                  'avSetting': 'off',
                  'aspectRatio': 'disable'
                }
              },
              'auxSourceSetting': {
                'enable': 'off',
                'settings': [
                  { 'av1': 'on' },
                  { 'av2': 'on' },
                  { 'av3': 'on' },
                  { 'rgb': 'on' },
                  { 'comp1': 'on' },
                  { 'comp2': 'on' },
                  { 'comp3': 'on' },
                  { 'hdmi1': 'on' },
                  { 'hdmi2': 'on' },
                  { 'hdmi3': 'on' },
                  { 'hdmi4': 'on' }
                ]
              },
              'powerManagement': 'off',
              'radioVideoBlank': {
                'enable': 'off',
                'settings': { 'startOfRadioProgramme': 1, 'countOfRadioProgramme': 1 }
              }
            }
          },
          "onSuccess" : function(s) {
            console.log("========================onSuccess-setHotelMode :", s);
        },
        "onFailure" : function(f) {
            console.log("========================onFailure-setHotelMode : errorMessage = " + f.errorMessage);
        }
        });
      } catch(error) {
        console.log('ERROR: hcap setProperty', error);
      }
    },
  },
  /*mounted: function() {
    let connection = new WebSocket('ws://localhost:3333/');
    connection.onmessage = (event) => {
      console.log('LOG SOCKET OPEN', event);
      const message = JSON.parse(event.data);
      //messages.value.push(message);
    };
    const sendMessage = (username, text) => {
      const messageData = { username: username, message: text};
      // Send the message data to the server using WebSockets
      connection.send(JSON.stringify(messageData));
      // Add the message data to the messages array
      //messages.value.push(messageData);
    };
    setTimeout(function() {
      console.log("Callback Funktion SENDMESSAGE");
      sendMessage("NAME", "TEXT");
      }, 2000);
  }*/
  //beforeMount: function() {
    //beforeCreate: function() {
    //  var script = document.createElement('script');
    //  script.src = 'http://192.168.50.200:8080/static/hcap.js';
    //  script.setAttribute('type', 'text/javascript');
    //  document.body.appendChild(script);
    //(function(){if(!window.tizen){var s=document.createElement("script");s.src='/static/hcap.js';/*s.setAttribute('async', 'async');*/s.setAttribute('type','text/javascript');document.head.appendChild(s);}})();
    /*
    if(!window.tizen) {
      var s = document.createElement("script");
      s.src = '/static/hcap.js';
      s.setAttribute('type','text/javascript');
      document.head.appendChild(s);
    }
    */
  //},
  mounted: function() {
    //(function(){if(!window.tizen){var s=document.createElement("script");s.src='/static/hcap.js';/*s.setAttribute('async', 'async');*/s.setAttribute('type','text/javascript');document.head.appendChild(s);}})():
    if(process.env.DEBUG) {
      console.log('DEBUG MODE ON');
      //(function(){var s=document.createElement("script");s.src="https://remotejs.com/agent/agent.js";s.setAttribute("data-consolejs-channel","34d0f378-fb40-e221-2f1f-10590c88be94");document.head.appendChild(s);})();
      var script = document.createElement('script');
      script.src = process.env.DEBUG;
      //script.async;
      document.head.appendChild(script);
    } else {
      console.log('DEBUG MODE OFF');
    }
    // TV-Geräte-Performance Optimierung
    requestAnimationFrame(() => {
      if(typeof window.focus === 'function') {
        window.focus();
      }
    });
    // LG-Fallback: sollte die Inline-Erkennung aus index.html aus irgendeinem
    // Grund (blockierende externe Scripts) noch nicht gelaufen sein, hier
    // synchron nachholen, damit _initHcap garantiert ausgeloest wird.
    if (window.isLG === undefined || window.isLG === null) {
      var ua = (navigator && navigator.userAgent) || '';
      var isLGUA = !window.tizen && (ua.indexOf("LGE") > 0 || ua.indexOf("WebOS") > 0 || ua.indexOf("webOS") > 0 || ua.indexOf("STB-") > 0);
      window.isLG = isLGUA;
      if (isLGUA && !window.lgVersion) {
        window.lgVersion = ua.indexOf("STB-5500") > 0 ? '3.5' : '5.0';
      }
    }
    // hcap-Initialisierung: sofort falls bereit, sonst auf 'hcap-ready' Event warten
    if (window.isLG) {
      const runHcap = () => {
        DeviceType.refineWebOSVersion();
        this._initHcap();
      };
      if (typeof hcap !== 'undefined' || window.hcapReady) {
        runHcap();
      } else {
        window.addEventListener('hcap-ready', runHcap, { once: true });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js